import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {
  const products = [
    {
      name: 'Trafik Sigortası',
      icon: '/why/trafiksigortasi.png',
      link: '/trafik-sigortasi'
    },
    {
      name: 'Kasko',
      icon: '/why/kasko.png',
      link: '/kasko'
    },
    {
      name: 'Sağlık Sigortası',
      icon: '/why/tamamlayicisaglik.png',
      link: '/tamamlayici-saglik-sigortasi'
    },
    {
      name: 'DASK',
      icon: '/why/konutsigortasi.png',
      isComingSoon: true
    }
  ];

  return (
    <div className="container mx-auto px-4 py-8 md:py-12">
      <div className="flex flex-col md:flex-row items-center justify-between">
        <div className="w-full md:w-1/2 text-center md:text-left mb-8 md:mb-0 md:pl-12">
          <h1 className="text-3xl md:text-6xl font-bold mb-4">
            Farklı <span style={{ color: '#0083ff' }}>Sigortacılık.</span>
          </h1>
          <h2 className="text-3xl md:text-6xl font-bold mb-8">Bizi Keşfedin.</h2>
          
          <p className="text-lg md:text-xl mb-8">Size Nasıl Yardımcı Olabiliriz ?</p>
          
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-6">
            {products.map((product) => (
              product.isComingSoon ? (
                <div key={product.name} className="h-full">
                  <div className="bg-white p-4 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center relative h-full">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-blue-50 rounded-full flex items-center justify-center mb-3">
                      <img 
                        src={product.icon}
                        alt={product.name}
                        className="w-8 h-8 md:w-16 md:h-16 object-contain filter-navy opacity-50"
                        style={{
                          filter: 'brightness(0) saturate(100%) invert(18%) sepia(90%) saturate(2645%) hue-rotate(212deg) brightness(95%) contrast(101%)'
                        }}
                      />
                    </div>
                    <span className="text-sm md:text-base font-medium text-center min-h-[2.5rem] flex items-center justify-center opacity-50">
                      {product.name}
                    </span>
                    <span className="absolute top-2 right-2 bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-1 rounded">
                      Yakında
                    </span>
                  </div>
                </div>
              ) : (
                <Link key={product.name} to={product.link} className="block h-full">
                  <div className="bg-white p-4 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center cursor-pointer h-full">
                    <div className="w-12 h-12 md:w-16 md:h-16 bg-blue-50 rounded-full flex items-center justify-center mb-3">
                      <img 
                        src={product.icon}
                        alt={product.name}
                        className="w-8 h-8 md:w-16 md:h-16 object-contain filter-navy"
                        style={{
                          filter: 'brightness(0) saturate(100%) invert(18%) sepia(90%) saturate(2645%) hue-rotate(212deg) brightness(95%) contrast(101%)'
                        }}
                      />
                    </div>
                    <span className="text-sm md:text-base font-medium text-center min-h-[2.5rem] flex items-center justify-center">
                      {product.name}
                    </span>
                  </div>
                </Link>
              )
            ))}
            <Link to="/sigorta-urunleri" className="block h-full">
              <div className="bg-white p-4 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex flex-col items-center cursor-pointer h-full">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-blue-50 rounded-full flex items-center justify-center mb-3">
                  <span className="text-blue-900 text-2xl md:text-3xl">→</span>
                </div>
                <span className="text-sm md:text-base font-medium text-center min-h-[2.5rem] flex items-center justify-center">
                  Tümünü Gör
                </span>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;